import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import { Link } from 'react-router-dom';
import api from '../../connection/Axios';
import icoArrowDown from '../../assets/icoArrowDown.png'
import icoArrowUp from '../../assets/icoArrowUp.png'
import icoArrowRight from '../../assets/icoArrowRight.png'
import moment from 'moment-timezone';


const VistoriasEmAberto = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [vistorias, setVistorias] = useState([])
  const [filterBy, setFilterBy] = useState('todos')
  const [sortBy, setSortBy] = useState(null);
  const [ordem, setOrdem] = useState('cresc')

  const sortData = (criteria) => {
    let sortedData;

    switch (criteria) {
      case 'dataHora': // Supondo que o campo de data seja chamado 'date'
        sortedData = [...vistorias].sort((a, b) => new Date(b.dataHora) - new Date(a.dataHora));
        break;
        case 'ID':
          sortedData = [...vistorias].sort((a, b) => b.id - a.id);
          break;
        case 'Status':
          sortedData = [...vistorias].sort((a, b) => a.status.localeCompare(b.status));
          break;
        case 'empreend':
          sortedData = [...vistorias].sort((a, b) => a.empreend.localeCompare(b.empreend));
          break;
      default:
        return;
    }

    setVistorias(sortedData);
    setSortBy(criteria);
  };


  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

    const data = {
      company: userData?.role === 'cliente' || userData.role === 'clienteAdm' ? userData?.companyId : null
    }
  
    async function GetServices() {
      api.post('vistoria/getServices', data, headers).then(response => {
        setVistorias(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetServices()
    }, [])

    console.log(vistorias)

    const Box = (props) => {

      const StatusColor = () => {
        switch (props.data.status) {
            case 'naoiniciada' : return <div style={{borderColor: '#c1c1c1', color: '#c1c1c1'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Não Iniciada</b></div>
            case 'pendente' : return <div style={{borderColor: '#ff8536', color: '#ff8536'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Pendente</b></div>
            case 'atencao' : return <div style={{borderColor: '#aa0000', color: '#aa0000'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Atenção</b></div>
            case 'resolvido' : return <div style={{borderColor: '#494949', color: '#494949'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Resolvida</b></div>
            default : return '#000000' 
        }
    }

      return(
        <>
        
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', flex: 1}}>
            <div style={styles.vistoria}>
            <div style={{width: 200}}>
                <div style={{color: '#000000', fontSize: 13, fontWeight: 600}}>{props.data.empreend}</div>
                <div style={{color: '#ed6e2d', fontSize: 13, fontWeight: 600, marginRight: 15}}>{props.data.id}</div>
              </div>  
              
                <div style={{width: 280}}>
                  
                </div>
                
                  <StatusColor />
                  <Button component={Link} to="/vistoria-detalhe" state={{data: props.data}} style={{backgroundColor: '#ffffff', paddingLeft:20, border: 'none'}}>
                    <img src={icoArrowRight} width='10' />
                  </Button>
                

            </div>
          </div>
        </>
      )
    }

  return (
    <>
        <Layout breadcrumb='Dashboard / Inspeções / Inspeções em aberto' title='Inspeções em aberto'>

          <div style={{display: 'flex', marginBottom: 20, alignItems: 'center'}}>
            Ordenar por: &nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('Status')}}>{sortBy === 'Status' ? <b>Status</b> : 'Status'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('ID')}}>{sortBy === 'ID' ? <b>ID</b> : 'ID'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('dataHora')}}>{sortBy === 'dataHora' ? <b>Agenda</b> : 'Agenda'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('empreend')}}>{sortBy === 'empreend' ? <b>Nome</b> : 'Nome'}</Button>&nbsp;&nbsp;
          </div>
          <div style={{display: 'flex', marginBottom: 20, alignItems: 'center'}}>
            Filtrar status por: &nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{setFilterBy('todos')}}>{filterBy === 'todos' ? <b>Todos os status</b> : 'Todos os status'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{setFilterBy('pendente')}}>{filterBy === 'pendente' ? <b>Pendentes</b> : 'Pendentes'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{setFilterBy('atencao')}}>{filterBy === 'atencao' ? <b>Atenção</b> : 'Atenção'}</Button>&nbsp;&nbsp;
          </div>
          <div style={{textTransform: 'capitalize'}}>
            <div style={{marginTop: 20, marginBottom: 15, textAlign: 'right'}}>
              Ordenado por: <b>{sortBy ? sortBy : 'Nenhum critério'}</b> - Filtrado por <b>{filterBy}</b>
            </div>
          </div>

          {vistorias.length != 0 ? vistorias.reverse().filter(filterBy != 'todos' ? vistoria => vistoria.status === filterBy : vistoria => vistoria.status === 'pendente' || vistoria.status === 'atencao' || vistoria.status === 'naoiniciada').map((vistoria, index)=>(
              <Box data={vistoria} key={index} />
            )) : null}


        </Layout>
    </>
  );
};

export default VistoriasEmAberto

const styles = {
  vistoria: {
      backgroundColor: '#FFFFFF',
      padding: 20,
      borderRadius: 12,
      marginBottom: 10,
      display: 'flex',
      color: '#000000',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%'
  },
  vistoria2: {
      backgroundColor: '#002638',
      padding: 20,
      borderRadius: 12,
      marginBlock: 20,
      display: 'flex',
      color: '#ffffff',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      fontSize: 15
  },
  setaOn: {
    
  },
  setaOff: {
    transform: [{rotateX: 180}],

  }
}